import { render, staticRenderFns } from "./channels.vue?vue&type=template&id=62113232&"
import script from "./channels.vue?vue&type=script&lang=js&"
export * from "./channels.vue?vue&type=script&lang=js&"
import style0 from "./channels.vue?vue&type=style&index=0&id=62113232&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports